export default __webpack_public_path__ + "static/media/two_of_swords.2e55e68c.png";